import React from 'react';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, className }) => (
  <div className={cn('flex flex-col items-center justify-center gap-3 px-6 py-14 text-center', className)}>
    {icon && (
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-3 text-foreground-subtle">
        {icon}
      </div>
    )}
    <div>
      <h3 className="font-display text-lg font-semibold text-foreground">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-foreground-muted">{description}</p>}
    </div>
    {action}
  </div>
);
